"use client"

import styles from "./TabBar.module.css"
import { ActiveIconName, Icon } from "@components/icons/Icon"
import clsx from "clsx"
import { useSearchParams } from "next/navigation"
import { parseSearchParams, View } from "@/app/helpers/utils/parseSearchParams"
import { updateUrlParams } from "@/app/helpers/utils/navigation"
import { Suspense } from "react"

interface TabBarProps {}

function TabBarContent() {
  const searchParams = useSearchParams()
  const { view } = parseSearchParams(searchParams)

  const handleClick = (label: View) => {
    if (label === "home" || label === "settings") {
      updateUrlParams(searchParams, { view: label })
    }
  }

  const tabs: {
    label: View
    iconName: ActiveIconName
    viewsToHighlight?: View[]
  }[] = [
    {
      label: "home",
      viewsToHighlight: ["home"],
      iconName: ActiveIconName.SquareChecklist,
    },
    {
      label: "messages",
      viewsToHighlight: ["messages"],
      iconName: ActiveIconName.SquarePlaceholderDashed,
    },
    // {
    //   label: "tasks",
    //   viewsToHighlight: ["tasks"],
    //   iconName: ActiveIconName.SquarePlaceholderDashed,
    // },
    // {
    //   label: "calendar",
    //   viewsToHighlight: ["calendar"],
    //   iconName: ActiveIconName.SquarePlaceholderDashed,
    // },
    {
      label: "settings",
      viewsToHighlight: ["settings", "linkedAccounts"],
      iconName: ActiveIconName.SettingsGear,
    },
  ]
  return (
    <div className={styles.container}>
      {tabs.map((t) => (
        <div
          key={t.label}
          onClick={() => handleClick(t.label)}
          className={clsx(
            styles.tab,
            t.viewsToHighlight?.includes(view) ? styles.active : "",
          )}
        >
          <Icon
            name={t.iconName}
            isFilled={t.viewsToHighlight?.includes(view) || false}
            customColor={
              t.viewsToHighlight?.includes(view) ? "#171717" : "#171717CC"
            }
          />
        </div>
      ))}
    </div>
  )
}

export default function TabBar({}: TabBarProps) {
  return (
    <Suspense fallback={<div></div>}>
      <TabBarContent />
    </Suspense>
  )
}
